/**
 * @file App.jsx
 * @description Root component aplikasi.
 * Mengatur routing, global styles, dan inisialisasi AOS animation.
 */
import React, { useEffect, Suspense } from 'react';
import { Switch, Route } from 'react-router-dom';
import AOS from 'aos';
import { useGetOrganizationContentQuery } from '../services/apiSlice';

// Global styles
import '../assets/css/pe-icon-7.css';
import 'aos/dist/aos.css';
import '../assets/scss/themes.scss';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// Route definitions
import routes from './routes';

// Loading fallback component
import LoadingOverlay from '../components/common/LoadingOverlay';
import UnderConstruction from '../components/common/UnderConstruction/UnderConstruction';

/**
 * App — Root functional component.
 * Menggantikan class component sebelumnya dengan hooks.
 */
const App = () => {
  const { data, isLoading, isError } = useGetOrganizationContentQuery();

  useEffect(() => {
    AOS.init();
  }, []);

  if (isLoading) {
    return <LoadingOverlay />;
  }

  // Jika API mengembalikan error, atau data gagal dimuat (kosong) / tidak ada organizationId
  if (isError || !data?.organizationId) {
    return <UnderConstruction />;
  }

  return (
    <Suspense fallback={<LoadingOverlay />}>
      <Switch>
        {routes.map((route, index) => (
          <Route
            key={index}
            path={route.path}
            component={route.component}
          />
        ))}
      </Switch>
    </Suspense>
  );
};

export default App;
